import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
interface BonusSectionProps {
  onScrollToPurchase: () => void;
}
export function BonusSection({
  onScrollToPurchase
}: BonusSectionProps) {
  const bonuses = [{
    title: 'Bonus 1 – Sustratos Caseros',
    description: 'Qué usar según el tipo de planta. Opciones simples y económicas.',
    image: 'https://cdn.magicpatterns.com/uploads/totioW9wukeePVXHmmgj1k/Preparacion_Y_Uso_Correcto,_Errores_Frecuentes,_Reutilizacion_Y_Mantenimiento,_-_1_-_Editado.png'
  }, {
    title: 'Bonus 2 – Guía Rápida de Plantas Populares',
    description: 'Qué plantas enraízan mejor y cómo hacerlo. Incluye capítulo especial suculentas.',
    image: 'https://cdn.magicpatterns.com/uploads/8rC7hjVogwg9JFQ8HzPr93/ChatGPT_Image_15_dic_2025,_14_45_11.png'
  }, {
    title: 'Bonus 3 – Hormonas de Enraizamiento',
    description: 'Opciones naturales y comerciales para mejorar el prendimiento.',
    image: 'https://cdn.magicpatterns.com/uploads/p95eoeVhzzvem8iRFdV1MY/Diseno_Sin_Titulo_-_1_-_Editado_(1).png'
  }, {
    title: 'Bonus 4 – Mini Invernadero Casero',
    description: 'Cómo armarlo con materiales simples para proteger y mantener humedad.',
    image: 'https://cdn.magicpatterns.com/uploads/3g3y5rKZVFP3D2qiTAM54M/Diseno_Sin_Titulo_-_1_-_Editado.png'
  }, {
    title: 'Bonus 5 – Calendario del Esqueje',
    description: 'Cuándo cortar, trasplantar y acompañar cada etapa.',
    image: 'https://cdn.magicpatterns.com/uploads/s681JfyaxRgShj2SHDVSV4/ChatGPT_Image_15_dic_2025,_14_41_41_-_Editado.png'
  }];
  return <section className="py-16 md:py-24 bg-[#2d5016] text-white overflow-hidden" data-id="element-23">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-24">
        <div className="text-center mb-16" data-id="element-25">
          <span className="inline-block px-4 py-1.5 mb-6 text-sm font-bold tracking-wider text-[#2d5016] bg-[#8bc34a] rounded-full" data-id="element-26">
            VALOR AGREGADO
          </span>
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-27">
            🎁 BONOS EXCLUSIVOS (incluidos hoy)
          </h2>
          <p className="text-xl text-[#a5d6a7]" data-id="element-28">
            Herramientas extra para asegurar tu éxito
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-29">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#1a330a] rounded-2xl overflow-hidden border border-[#4a7c2c] hover:border-[#8bc34a] transition-colors group cursor-pointer" onClick={onScrollToPurchase} data-id="element-30">
              <div className="relative h-48 bg-[#0f2205] flex items-center justify-center overflow-hidden" data-id="element-31">
                {bonus.image ? <img src={bonus.image} alt={bonus.title} className="h-full w-auto object-contain transform transition-transform duration-500 group-hover:scale-110" data-id="element-32" /> : <Gift className="w-16 h-16 text-[#4a7c2c] opacity-50" data-id="element-33" />}
                <div className="absolute top-4 right-4 bg-[#d32f2f] text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg" data-id="element-34">
                  GRATIS HOY
                </div>
              </div>
              <div className="p-6" data-id="element-35">
                <h3 className="text-lg font-bold text-[#8bc34a] mb-3" data-id="element-36">
                  {bonus.title}
                </h3>
                <p className="text-[#e8f5e9] text-sm leading-relaxed" data-id="element-37">
                  {bonus.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-38">
          <p className="text-2xl font-bold text-white flex items-center justify-center gap-2" data-id="element-39">
            👉 Todos GRATIS con tu compra hoy
          </p>
        </div>
      </div>
    </section>;
}